import React, { useState, Fragment } from 'react';
// import Tabs from '../FindTheError/partials/Tabs/Tabs';
import '../../partials/ClickBitInteraction/ClickBitInteraction.scss';
import Scroll from '../../../../partials/Scroll/Scroll';
import Modal from '../../../../partials/Modal/Modal'
import TabNavigation from '../../../../partials/TabsContainer/TabNavigation'
import Hotspot from '../HotSpots/Hotspot';

const SingleSelectHorizontal = (props) => {

  const { data, nextTab, onComplete, key } = props;

  const [optionSelected, setOptionSelected] = useState(0);
  const [blockSelection, setBlockSelection] = useState(false);
  const [errors, SetErrors] = useState(false);
  const [showRight, setShowRight] = useState(false);
  const [showImageOne, setShowImageOne] = useState(false);
  const [currentHotSpot, setCurrentHotSpot] = useState(0);
  const maxLimit = 45;
  const [source, setSource] = useState(() => {
    return {
      ...data,
      options: data.options.map(o => {
        return {
          ...o,
          isComplete: false,
          hotspots: o.hotspots.map(h => {
            return {
              ...h,
              hotspotClicked: false
            }
          })
        }
      })
    }

  })

  const nextOption = () => {
    if (data.options.length > optionSelected + 1) {
      setCurrentHotSpot(0)
      setOptionSelected(optionSelected + 1);
    } else {
      onComplete(false)
    }
  }

  const resetStep = () => {
    setOptionSelected();
    setBlockSelection(false);
    SetErrors(false);
  }

  const tabChange = (optionIndex) => {
    !blockSelection && setOptionSelected(optionIndex);
    setShowRight(false);
  }

  const passValidation = () => {
    if (!source.options[optionSelected].correct && !errors) {
      SetErrors(true);
    }
    return errors;
  }

  return <div className="single-select-horizontal1">
    <Modal onClose={() => { }}>
      <p>Test Modal</p>
    </Modal>
    <TabNavigation
      data={source.options.map((tabItem) => ({ ...tabItem, name: tabItem.text }))}
      selected={optionSelected}
      onSelectHandle={(selectedTabItem, itemIndex) => { tabChange(itemIndex) }}
    />
    <div className="notes">
      {
        source.options.map((option, optionIndex) => (
          <Fragment key={`note-${optionIndex}`}>
            {!blockSelection && optionSelected === optionIndex &&
              <>
                {option.image ? <div style={{ display: 'flex', maxHeight: '425px', width: '1060px', }}>
                  <div className="lefttest">
                    <Scroll>
                      <div className="scroll_ht">
                        {option.hotspots.map((hotspot, hotspotIndex) => (
                          <React.Fragment>
                            <Hotspot
                              coordinates={hotspot.coordinates}
                              onClick={() => {
                                source.options[optionIndex].hotspots[hotspotIndex] = { ...source.options[optionIndex].hotspots[hotspotIndex], hotspotClicked: true }
                                source.options[optionIndex].isComplete = source.options[optionIndex].hotspots.every(h => h.hotspotClicked == true)
                                setShowRight(true)
                                setSource(source)
                                setCurrentHotSpot(hotspotIndex)
                              }}
                              index={hotspotIndex} />
                          </React.Fragment>
                        )
                        )}
                        <img src={option.image} />
                      </div>
                    </Scroll>
                  </div>
                  {showRight ? (<div className="righttest"><Scroll><div className="scroll_ht scroll_ht1" dangerouslySetInnerHTML={{ __html: option.hotspots[currentHotSpot].content }}></div></Scroll></div>) : <div></div>}
                  <div className="clear"></div>
                </div> : <div></div>}
              </>
            }
          </Fragment>
        ))
      }
      <div className="progress-meters">
        {
          source.options.map((option, optionIndex) => {
            return <div key={`pm-${optionIndex}`} className={`progress-meter ${option.isComplete ? 'completed' : ''}`}></div>
          })
        }
      </div>
    </div>
    <div className="clear"></div>
    <button className="green nxt_btn" onClick={nextOption}>
      Next <i className="fa fa-chevron-right"></i>
    </button>
    {optionSelected !== null && optionSelected !== undefined &&
      <div className="action">
      </div>
    }

  </div>

}

export default SingleSelectHorizontal;